import script from "./YourId.vue?vue&type=script&setup=true&lang=ts"
export * from "./YourId.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__